export default "__VITE_ASSET__1QxyYW9K__"